import React, { useState } from "react";
import styles from "./Drawing.module.scss";
import { Upload } from "@progress/kendo-react-upload";
import { HOST_API } from "../../config-global";
import axios from "axios";
import { Loader } from "@progress/kendo-react-indicators";
import { toast } from "react-toastify";
import usePreviewStore from "../../store/preview-store";
import useOrderStore from "../../store/order-store";
import { useParams } from "react-router-dom";
const Drawing = ({ updater, type }) => {
  const { id } = useParams();
  const [files, setFiles] = useState([]);
  const [bluePrint, setBluePrint] = useState(null);
  const [loading, setLoading] = useState(false);
  const { previewData, setFormData } = usePreviewStore();
  const { orderData, setFormData: setOrderFormData } = useOrderStore();

  const handleAdd = async (event) => {
    setLoading(true);
    const newFiles = event.affectedFiles.map((fileWrapper) =>
      fileWrapper.getRawFile()
    );
    const formData = new FormData();
    formData.append("files", newFiles[0]);
    formData.append("id", id);

    try {
      const response = await axios.post(
        `${HOST_API}/blueprint/v1/create`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Image Uploaded Successfully");
      let { data } = response.data;
      console.log("Uploaded file data:", data);
      if (type == "gutter") {
        setFormData({
          ...previewData,
          images: data,
        });
      } else {
        setOrderFormData({
          ...orderData,
          images: data,
        });
      }

      setBluePrint(data);
      setLoading(false);
    } catch (error) {
      toast.error("Something went wrong. Please try again later");
      console.error("File upload failed:", error);
      setBluePrint(null);
      setLoading(false);
    }
  };

  const handleRemove = (event) => {
    const removedFile = event.affectedFiles[0].getRawFile(); // Get the raw file object
    setFiles(
      (prevFiles) => prevFiles.filter((file) => file.name !== removedFile.name) // Compare by file name
    );
    updater(files.filter((file) => file.name !== removedFile.name));
  };

  return (
    <div className={`${styles.uploaderContainer}`}>
      <Upload
        batch={false}
        multiple={false}
        defaultFiles={[]}
        withCredentials={false}
        saveUrl={"https://demos.telerik.com/kendo-ui/service-v4/upload/save"}
        removeUrl={
          "https://demos.telerik.com/kendo-ui/service-v4/upload/remove"
        }
        onAdd={handleAdd} // Handle file addition
        onRemove={handleRemove} // Handle file removal
        showFileList={false}
      />
      {bluePrint && !loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          <img
            style={{ height: "auto" }}
            width={type !== "gutter" ? 350 : 200}
            src={bluePrint}
            alt="Blueprint preview"
          />
        </div>
      )}
      {type === "gutter" &&
        !bluePrint &&
        !loading &&
        previewData?.images?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <img
              style={{ height: "auto" }}
              width={200}
              src={previewData.images[0]}
              alt="Blueprint preview"
            />
          </div>
        )}
      {type !== "gutter" &&
        !bluePrint &&
        !loading &&
        orderData?.images?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <img
              style={{ height: "auto" }}
              width={350}
              src={orderData.images[0]}
              alt="Blueprint preview"
            />
          </div>
        )}
      {loading && (
        <div className="k-display-flex k-justify-content-center k-mt-10">
          <Loader
            themeColor="success"
            size="medium"
            type={"infinite-spinner"}
          />
        </div>
      )}
    </div>
  );
};

export default Drawing;
